//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdmSpisovyZnak.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Spisov� znak </Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-02-11                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.11.4
//AdtGeneratorConfig:[ T:(sslsspz) GID:(Web.Dia.Ts) V1:(spis_pl,spis_znak) V2:() K1:() K2:() ]

namespace Gordic.Adm.Dialogs {

    // AdmSpisovyZnak
    export function DetailAdmSpisovyZnakDlg(
        parentContent: GContent,
        opt: {
            /** spis_pl */
            spis_pl: string | null,
            /** spis_znak */
            spis_znak: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdmSpisovyZnak', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdmSpisovyZnak#",
        spis_pl: opt ? opt.spis_pl : undefined,
        spis_znak: opt ? opt.spis_znak : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdmSpisovyZnak
    export function SeznamAdmSpisovyZnakDlg(
        parentContent: GContent,
        opt: {
            /** spis_pl */
            spis_pl: string | null,
            /** spis_znak */
            spis_znak: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdmSpisovyZnak', { }]

    const options = {
        ID: "AdmAdmSpisovyZnak#",
        spis_pl: opt ? opt.spis_pl : undefined,
        spis_znak: opt ? opt.spis_znak : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
